export default "__VITE_ASSET__BOitbDnJ__"